import { useShouldUseAssignmentV3 } from './useShouldUseAssignmentV3';
import { useShouldUseBuckets } from './useShouldUseBuckets';

export type AssignmentVersion = 'v3' | 'buckets' | 'legacy';

type UseShouldUseAssignmentsVersionParams = {
  applicationID?: string;
  marketCountry?: string;
};

export const useShouldUseAssignmentsVersion = ({
  applicationID,
  marketCountry,
}: UseShouldUseAssignmentsVersionParams): AssignmentVersion => {
  const isV3 = useShouldUseAssignmentV3({
    applicationID,
    marketCountry,
  });
  const isBuckets = useShouldUseBuckets();

  if (isV3) {
    return 'v3';
  } else if (isBuckets) {
    return 'buckets';
  } else {
    return 'legacy';
  }
};
